import { SimpleGrid } from '@chakra-ui/react';
import { IGetCreditSchema } from '@monetize/types/app';
import { formatCurrency, toDateShort } from '@monetize/utils/core';
import { ROUTES } from '../../../constants';
import {
  CreditStatusEnumDisplay,
  CreditTypeEnumDisplay,
} from '../../../constants/credits';
import { MFormFieldReadOnly } from '../MFormFieldReadOnly';
import { LookupTriggerContent } from './LookupTriggerContent';
import { RecordLookupPopover } from './RecordLookupPopover';
import { RecordLookupPopoverHeader } from './RecordLookupPopoverHeader';

export interface CreditLookupPopoverProps {
  value: string;
  displayLabel?: string;
}

export function CreditLookupPopover({
  value,
  displayLabel,
}: CreditLookupPopoverProps) {
  if (!value) {
    return null;
  }
  return (
    <RecordLookupPopover
      recordId={value}
      endpoint={`/api/credits/${value}`}
      buttonProps={{ lineClamp: 3 }}
      renderRecord={(record) => {
        const credit = record as IGetCreditSchema;
        const recordName = credit.name ?? credit.id ?? value;
        return (
          <>
            <RecordLookupPopoverHeader
              recordId={credit.id}
              href={ROUTES.getAccountCreditsViewRoute(
                credit.accountId,
                credit.id,
              )}
              recordName={recordName}
              displayStatus={CreditStatusEnumDisplay[credit.status]}
            />

            <SimpleGrid columns={2} gap={2} mt={2}>
              <MFormFieldReadOnly label="Type">
                {CreditTypeEnumDisplay[credit.type]}
              </MFormFieldReadOnly>
              <MFormFieldReadOnly label="Amount">
                {formatCurrency(credit.amount, { currency: credit.currency })}
              </MFormFieldReadOnly>
              <MFormFieldReadOnly label="Amount Remaining">
                {formatCurrency(credit.amountRemaining, {
                  currency: credit.currency,
                })}
              </MFormFieldReadOnly>
              <MFormFieldReadOnly label="Expiration Date">
                {credit.expirationDate
                  ? toDateShort(credit.expirationDate)
                  : '-'}
              </MFormFieldReadOnly>
            </SimpleGrid>
          </>
        );
      }}
    >
      <LookupTriggerContent displayLabel={displayLabel} value={value} />
    </RecordLookupPopover>
  );
}
